import { BehaviorSubject } from "rxjs";
import { hookFromSubject, promiseToSubject, ResponseSubjectState } from "./index";
import { CompanyApi, CompanyCreateEditDto, CompanyListItemDto, Configuration } from "../generated-api";
import { getCustomHeaders } from "./user";

const { REACT_APP_API_DOMAIN } = process.env;
const companyApi = new CompanyApi(new Configuration({ basePath: REACT_APP_API_DOMAIN, getHeaders: getCustomHeaders }));

export const companySubject = new BehaviorSubject(new ResponseSubjectState());
export const useCompany = hookFromSubject(companySubject);
export const getCompany = () =>
    promiseToSubject(companyApi.apiCompanyGet(), companySubject);

export const companyCreateSubject = new BehaviorSubject(new ResponseSubjectState());
export const useCompanyCreate = hookFromSubject(companyCreateSubject);
export const createCompany = (body?: CompanyCreateEditDto) =>
    promiseToSubject(companyApi.apiCompanyPost(body), companyCreateSubject);

export const companyGuidSubject = new BehaviorSubject(new ResponseSubjectState());
export const useCompanyGuid = hookFromSubject(companyGuidSubject);
export const getCompanyGuid = (guid: string, suppressErrors?: boolean) =>
    promiseToSubject(companyApi.apiCompanyGuidGet({ guid }), companyGuidSubject, { suppressErrors: suppressErrors });

export const companyStatusesSubject = new BehaviorSubject(new ResponseSubjectState());
export const useCompanyStatuses = hookFromSubject(companyStatusesSubject);
export const getCompanyStatuses = () =>
    promiseToSubject(companyApi.apiCompanyStatusesGet(), companyStatusesSubject);

export const companyStatusUpdateSubject = new BehaviorSubject(new ResponseSubjectState());
export const useCompanyStatusUpdate = hookFromSubject(companyStatusUpdateSubject);
export const updateCompanyStatus = (guid: string, status: string) =>
    promiseToSubject(companyApi.apiCompanyGuidActiveStatusPut({ guid, status }), companyStatusUpdateSubject);

export const getCompanyMe = (suppressErrors?: boolean) =>
    promiseToSubject(companyApi.apiCompanyMeGet(), companyGuidSubject, { suppressErrors: suppressErrors });

export const updateCompanyGuid = (guid: string, body?: CompanyCreateEditDto) =>
    promiseToSubject(companyApi.apiCompanyGuidPut({ guid }, body), new BehaviorSubject(new ResponseSubjectState()));

export const companyGuidDeleteSubject = new BehaviorSubject(new ResponseSubjectState());
export const useCompanyGuidDelete = hookFromSubject(companyGuidDeleteSubject);
export const deleteCompanyGuid = (guid: string) =>
    promiseToSubject(companyApi.apiCompanyGuidDelete({ guid }), companyGuidDeleteSubject);

export function getGuarDocCompanies(companies: CompanyListItemDto[], companyType: 1 | 2): CompanyListItemDto[] {
    return companies.filter((item: CompanyListItemDto) => item.companyType === companyType);
}  